import useSWR from 'swr';
import type { Key as SWRKey } from 'swr';
import { useStore } from 'react-redux';
import { useServices } from '@packages/shared/core/common/hooks';
import type { Services } from '@packages/shared/core/common/context';
import type { RootInitialState } from '@packages/shared/core/common/store/rootReducer';
import type { QueryCacheProviderOptions } from '../entities';

type UseCachedQueryExtra = {
  services: Services;
  getState: () => RootInitialState;
};

type CachedQueryFetcherCreator<Data, Key> = (ctx: UseCachedQueryExtra) => (key: Key) => Promise<Data>;

// TODO: Allow Data type to be inferred from the fetcherCreator.
// LINK: https://genesismedia.atlassian.net/browse/MARTECH-340
export const useCachedQuery = <Data, Key extends SWRKey, Error = { message: string }>(
  key: Key,
  fetcherCreator: CachedQueryFetcherCreator<Data, Key>,
  options?: QueryCacheProviderOptions<Data, Error>,
) => {
  const store = useStore();
  const services = useServices();

  return useSWR<Data, Error, SWRKey>(key, fetcherCreator({ services: services, getState: store.getState }), options);
};
